import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  mobilePreviewButton: {
    marginRight: theme.spacing(1),
  },
}));

export default useStyles;
